const React = require('react');

module.exports = (props) => {
  return (
    <div
      {...props}
      className={`wmin130 pl19 pt13 pb14 f12 lh18 bgFAFAFA c0 br1 bsrSolid bcrE8E8E8 bcrTransparent:last-child`
        + (props.className || '')}
    />
  );
};
